"use client";

import React from "react";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-foreground/10 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-foreground/70 hover:text-foreground transition-colors text-sm font-sans">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/CollectionsPage" className="text-foreground/70 hover:text-foreground transition-colors text-sm font-sans">
            The Collections
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/InquiryPage" className="text-foreground/70 hover:text-foreground transition-colors text-sm font-sans">
            Inquire
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/70 hover:text-foreground transition-colors text-sm font-sans">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function FooterMenu() {
  return <MenuProvider menu_id="41">
      <FooterMenuConsumer />
    </MenuProvider>;
}
export default function Footer() {
  const categories = [{
    name: "Wedding Stories",
    href: "/CollectionsPage"
  }, {
    name: "Engagement Sessions",
    href: "/CollectionsPage"
  }, {
    name: "Fine Art Albums",
    href: "/ExperiencePage"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Youtube,
    href: "#",
    label: "YouTube"
  }];
  return <section data-section-id="259740" id="footer" className="bg-background text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <Separator className="bg-ring mb-16 h-[1px]" />
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            <p className="text-foreground/70 text-sm leading-relaxed max-w-xs font-sans">
              Ivory Lens captures timeless moments with a soft-toned aesthetic, creating elegant collections that reflect each couple’s unique story through artistic composition.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground tracking-tight">
              Studio
            </h3>
            <FooterMenu />
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground tracking-tight">
              Portfolios
            </h3>
            <ul className="flex flex-col gap-3">
              {categories.map((category, i) => <li key={category.name} data-index={i}>
                  <Link to={category.href} className="text-foreground/70 hover:text-foreground transition-colors text-sm font-sans">
                    {category.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground tracking-tight">
              Connect
            </h3>
            <div className="flex gap-4 mb-8">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} className="text-foreground/70 hover:text-foreground transition-colors" aria-label={social.label} data-index={i}>
                    <Icon className="size-5 stroke-[1.5px]" />
                  </Link>;
            })}
            </div>
            <div className="space-y-4">
              <p className="text-sm text-foreground/70 font-sans">
                Join our journal for wedding inspiration and seasonal availability updates.
              </p>
              <Button variant="outline" asChild className="w-full sm:w-auto border-border hover:bg-secondary rounded-md font-sans text-xs uppercase tracking-widest">
                <Link to="/InquiryPage">Request a Brochure</Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-border/30 mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-foreground/50 font-sans uppercase tracking-widest">
          <p>© {new Date().getFullYear()} Ivory Lens. Timeless Imagery.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">
              Privacy
            </Link>
            <Link to="#" className="hover:text-foreground transition-colors">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </section>;
}